export default __webpack_public_path__ + "static/media/unico-communication.9a760ac4.png";